import React from 'react';
import PropTypes from 'prop-types';

const UpdatedBy = ({ updatedBy }) => {
  const title = updatedBy.title || '';
  const professionType = updatedBy.professionType
    ? `- ${updatedBy.professionType}`
    : '';
  const firstName = updatedBy.firstName || '';
  const lastName = updatedBy.lastName || '';

  const doctorFullName = `${title} ${firstName} ${lastName} ${professionType}`;

  return (
    <div>
      By:&nbsp;
      <strong>{firstName || lastName ? doctorFullName : 'Evelyn'}</strong>
    </div>
  );
};

UpdatedBy.propTypes = {
  updatedBy: PropTypes.shape(),
};

export default UpdatedBy;
